import { Button, message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { CheckCircleOutlined, Loading3QuartersOutlined } from '@ant-design/icons';
import onScan from 'onscan.js';
import axios from '../../../util/Api';

const RfidSetup = ({ passport }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rfidNumber, setRfidNumber] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    if (rfidNumber) {
      saveRfidNumber();
    }
  }

  const handleCancel = () => {
    setRfidNumber(null);
    setIsModalVisible(false);
  }

  const saveRfidNumber = () => {
    setLoading(true);
    const url = `/passport/rfid-setup`;
    const data = {
      id: passport.id,
      rfid: rfidNumber
    };
    axios.post(url, data).then(resp => {
      setRfidNumber(null);
      window.location.reload();
    }).catch(err => {
      message.error('Gagal menyimpan kartu RFID');
      setLoading(false);
    });
  }

  /**
   * RFID scan process
   */
  useEffect(() => {
    if (!onScan.isAttachedTo(document)) {
      onScan.attachTo(document);
    }
    document.addEventListener('scan', (evt) => {
      const code = evt.detail.scanCode;
      setRfidNumber(code);
    });
  }, []);

  return passport.actions.rfid_setup ? (
    <div className="gx-text-center">
      <Button type={passport.rfid_number ? `secondary` : `primary`} size={passport.rfid_number ? "middle" : "large"} block className="gx-mb-0" onClick={() => setIsModalVisible(true)}>
        {passport.rfid_number ? `Atur Ulang Kartu RFID` : `Atur Kartu RFID`}
      </Button>
      {passport.rfid_number ? (
        <Button type="secondary" danger size="middle" block className="gx-mb-0 gx-mt-3" onClick={saveRfidNumber}>
          Hapus RFID
        </Button>
      ) : null}
      
      <Modal
        title="Atur Kartu RFID" visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Simpan"
        okButtonProps={{ loading: loading }}
      >
        {rfidNumber ? (
          <div>
            <CheckCircleOutlined className="gx-mr-2 gx-text-success" /> Kartu RFID Sukses Dibaca!
          </div>
        ) : <Placeholder />}
      </Modal>
    </div>
  ) : null;
}

export default RfidSetup;

const Placeholder = () => {
  return (
    <div className="rfid-placeholder">
      <Loading3QuartersOutlined spin className="gx-mr-2"/> Tempelkan kartu RFID pada Reader
    </div>
  );
}